import React from 'react';
import { Box } from '@mui/material';
import AppBarMain from '../unsecured/AppBarMain';
import OtcToolbar from '../unsecured/OtcToolbar';
import Footer from '../unsecured/Footer';

const MainLayout = ({ children }) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh',
      backgroundColor: '#FFFFFF'
    }}>
      {/* Header Section */}
      <Box sx={{ flexShrink: 0 }}>
        <AppBarMain />
        {/* <OtcToolbar /> */}
      </Box>

      {/* Main Content */}
      <Box sx={{ 
        flex: 1, 
        display: 'flex', 
        flexDirection: 'column',
        backgroundColor: 'aliceblue'
      }}>
        {children}
      </Box>

      {/* Footer */}
      <Box sx={{ flexShrink: 0 }}>
        <Footer />
      </Box>
    </Box>
  );
};

export default MainLayout;
